import React, { useContext } from 'react';
import styled from 'styled-components';
import { EditorContext } from '@/features/editor/context/editor-context';
import { Flexbox } from '@/components/flex';
import { DefaultTypography } from '@/components/typography';
import { DeviceType } from '@/utils/definitions';

export function DefaultInlineVariantsLayoutHeader({
  rightContent,
}: {
  rightContent?: React.ReactNode;
}) {
  const {
    devicePreview: {
      editorState: { device },
    },
  } = useContext(EditorContext);

  return (
    <Flexbox
      width="100%"
      direction="row"
      justify="space-between"
      align="center"
    >
      <InlineVariantsLayoutHeaderText device={device}>
        Set Variants
      </InlineVariantsLayoutHeaderText>
      {rightContent ?? (
        <InlineVariantsLayoutHeaderText
          device={device}
          style={{ marginRight: `1.3rem` }}
        >
          Allocation
        </InlineVariantsLayoutHeaderText>
      )}
    </Flexbox>
  );
}

export const InlineVariantsLayoutHeaderText = styled(DefaultTypography)`
  && {
    display: flex;
    color: black;
    font-size: ${({ device }: { device: DeviceType }) =>
      device === DeviceType.Desktop ? `1.3rem` : `1.3rem`};
    font-weight: 600;
  }
`;
